import React, { useState, useEffect } from "react";

export const Circle = (options) => {
  const [circle, setCircle] = useState();
  const [infoWindow, setInfoWindow] = useState();

  useEffect(() => {
    if (!circle) {
      setCircle(new window.google.maps.Circle());
    }

    // remove circle from map on unmount
    return () => {
      if (circle) {
        circle.setMap(null);
      }
    };
  }, [circle]);

  useEffect(() => {
    if (circle) {
      circle.setOptions(options);
    }
  }, [circle, options]);

  return null;
};
